import Modal from "../../../../shared/components/UI/Modal/Modal"
import './styles/ManageEventModal.scss'
import { Dispatch, SetStateAction, useState } from "react"
import CreateEventForm from "./components/CreateEventForm"
import { dialogNotify } from "../../../../shared/services/Notifications/NotificationServices"
import AdministrationEventForm from "./components/AdministrationEventForm"

interface ManageEventModalProps {
    mode: 'edit' | 'create'
    currentTab?: 'edit' | 'administration'
    eventSlug?: string
    eventName?: string
    canEdit?: boolean
    isOpen: boolean
    setIsOpen: Dispatch<SetStateAction<boolean>>
}

const ManageEventModal = ({ mode, currentTab, eventSlug, eventName, isOpen, setIsOpen, canEdit = true }: ManageEventModalProps) => {
    const [activeTab, setActiveTab] = useState<'edit' | 'administration'>(currentTab ? currentTab : 'edit')
    const [isFormDirty, setIsFormDirty] = useState(false)

    const isCreate = mode === 'create'

    const handleCloseModal = () => {
        if (isFormDirty) {
            dialogNotify({
                status: 'info',
                title: 'Изменения не сохранены',
                description: 'Вы уверены, что хотите покинуть вкладку? Все несохранённые изменения будут потеряны.',
                acceptHandler: () => {
                    setIsOpen(false)
                },
                acceptText: 'Да',
                rejectText: 'Отмена'
            })
            return
        }
        setIsOpen(false)
    }

    return (
        <Modal isOpen={isOpen} closeModal={handleCloseModal} className='manageEventModal'>
            <div className="manageEventModal__title">
                <h1>Мероприятие</h1>
                <p>{isCreate ? 'Новое мероприятие' : eventName}</p>
            </div>

            <div className={`manageEventModal__tabs ${isCreate && 'noneDisplay'}`}>
                {!isCreate && canEdit &&
                    <>
                        <div
                            className={`manageEventModal__tabs-item ${activeTab === 'edit' && 'active'}`}
                            onClick={() => setActiveTab('edit')}
                        >
                            Редактирование
                        </div>
                        <div
                            className={`manageEventModal__tabs-item ${activeTab === 'administration' && 'active'}`}
                            onClick={() => {
                                if (isFormDirty) {
                                    dialogNotify({
                                        status: 'info',
                                        title: 'Изменения не сохранены',
                                        description: 'Вы уверены, что хотите покинуть вкладку? Все несохранённые изменения будут потеряны.',
                                        acceptHandler: () => {
                                            setActiveTab('administration')
                                        },
                                        acceptText: 'Да',
                                        rejectText: 'Отмена'
                                    })
                                    return
                                } else {
                                    setActiveTab('administration')
                                }
                            }}
                        >
                            Администрирование
                        </div>
                    </>}
            </div>

            {activeTab === 'edit' &&
                <CreateEventForm
                    isCreate={isCreate}
                    eventSlug={eventSlug}
                    onDirtyChange={setIsFormDirty}
                    onClose={() => setIsOpen(false)}
                />
            }

            {activeTab === 'administration' &&
                <AdministrationEventForm
                    slug={eventSlug}
                />
            }
        </Modal>
    )
}

export default ManageEventModal